// KEATS bundle price display — May 27 2026
// Renders a prominent price banner above each BYO bundle widget on the PDP showing:
//   - Subscription selected: "$50.99 <s>$59.99</s>  Save 15% with subscription" (green badge)
//   - One-time selected:     "$59.99"
// Mirrors what the ATC button already shows, but positions it ABOVE the bundle picker
// so customers see the price before scrolling. Updates live when frequency dropdown changes.
(function () {
  'use strict';

  var BANNER_ID = 'keats-bundle-price-banner';

  function parseAtcPrices(atcEl) {
    if (!atcEl) return null;
    var txt = atcEl.textContent.replace(/\s+/g, ' ').trim();
    // Match patterns like "Add to cart: $59.99 $50.99" or "Add to cart: $59.99"
    var prices = txt.match(/\$(\d+(?:\.\d+)?)/g) || [];
    if (prices.length === 0) return null;
    return {
      compareAt: prices.length >= 2 ? prices[0] : null,
      current: prices.length >= 2 ? prices[1] : prices[0]
    };
  }

  function calcSavings(p) {
    if (!p || !p.compareAt || !p.current) return null;
    var was = parseFloat(p.compareAt.replace('$', ''));
    var now = parseFloat(p.current.replace('$', ''));
    if (!isFinite(was) || !isFinite(now) || now >= was) return null;
    var savedAmt = (was - now).toFixed(2);
    var savedPct = Math.round(((was - now) / was) * 100);
    return { amount: '$' + savedAmt, percent: savedPct };
  }

  function buildBanner(prices) {
    var savings = calcSavings(prices);
    var banner = document.createElement('div');
    banner.id = BANNER_ID;
    banner.style.cssText = [
      'display: flex',
      'flex-wrap: wrap',
      'align-items: baseline',
      'gap: 12px',
      'padding: 16px 20px',
      'margin: 0 0 20px 0',
      'background: #f8f8f5',
      'border-radius: 8px',
      'font-family: inherit',
      'border-left: 4px solid #445c11'
    ].join('; ');

    var current = document.createElement('span');
    current.style.cssText = 'font-size: 28px; font-weight: 700; color: #1a1a1a; line-height: 1;';
    current.textContent = prices.current;
    banner.appendChild(current);

    if (savings && prices.compareAt) {
      var was = document.createElement('span');
      was.style.cssText = 'font-size: 18px; color: #888; text-decoration: line-through; line-height: 1;';
      was.textContent = prices.compareAt;
      banner.appendChild(was);

      var badge = document.createElement('span');
      badge.style.cssText = [
        'font-size: 13px',
        'font-weight: 600',
        'color: #ffffff',
        'background: #445c11',
        'padding: 4px 10px',
        'border-radius: 4px',
        'letter-spacing: 0.3px',
        'text-transform: uppercase'
      ].join('; ');
      badge.textContent = 'Save ' + savings.percent + '% with subscription';
      banner.appendChild(badge);
    } else {
      var hint = document.createElement('span');
      hint.style.cssText = 'font-size: 13px; color: #666; line-height: 1;';
      hint.textContent = 'Subscribe & save 15%';
      banner.appendChild(hint);
    }

    return banner;
  }

  function findAtcButton() {
    return Array.from(document.querySelectorAll('button')).find(function (b) {
      var t = b.textContent.toLowerCase().replace(/\s/g, '');
      return t.indexOf('addtocart') === 0;
    });
  }

  function findInsertionPoint() {
    // Insert above the "Choose N" label (rendered as SPAN with shopify scoped classes)
    var widget = document.querySelector('.recharge-bundles-widget');
    if (!widget) return null;
    var all = widget.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.children.length === 0 && /^Choose\s+\d+/.test(el.textContent.trim())) {
        // Walk up to find a block-level container we can insert before
        var anchor = el;
        for (var d = 0; d < 4 && anchor.parentElement; d++) {
          anchor = anchor.parentElement;
          var disp = (window.getComputedStyle(anchor).display || '');
          if (disp === 'block' || disp === 'flex' || disp === 'grid') break;
        }
        return anchor;
      }
    }
    return widget.firstElementChild;
  }

  function render() {
    var atc = findAtcButton();
    var prices = parseAtcPrices(atc);
    if (!prices) return;

    var existing = document.getElementById(BANNER_ID);
    var anchor = findInsertionPoint();
    if (!anchor) {
      if (existing) existing.remove();
      return;
    }
    var newBanner = buildBanner(prices);
    if (existing) {
      existing.replaceWith(newBanner);
    } else {
      anchor.parentNode.insertBefore(newBanner, anchor);
    }
  }

  // Initial render after widget mounts
  var attempts = 0;
  var pollId = setInterval(function () {
    attempts++;
    if (findInsertionPoint() && findAtcButton()) {
      render();
      clearInterval(pollId);
      // Watch for ATC text changes (frequency dropdown switches)
      var atc = findAtcButton();
      if (atc) {
        var obs = new MutationObserver(function () { render(); });
        obs.observe(atc, { childList: true, characterData: true, subtree: true });
      }
      // Also watch frequency dropdown changes
      var widget = document.querySelector('.recharge-bundles-widget');
      if (widget) {
        widget.addEventListener('change', function (e) {
          if (e.target.tagName === 'SELECT') setTimeout(render, 100);
        }, true);
      }
    } else if (attempts > 60) {
      clearInterval(pollId);
    }
  }, 250);
})();
